import React, { useState } from "react";
import { Col, Dropdown, Row } from "react-bootstrap";
import useSlider from "../../hooks/useSlider";
import Sidebar from "../sidebar/Sidebar";
import Pagination from "../../utils/Pagination";
import {  useQuery } from "@tanstack/react-query";
import { BsThreeDotsVertical } from "react-icons/bs";
import {
    changeCompanyPlanStatus,
  getAllCompany,
  getCompanyPlansList,
} from "../../services/services";
import { constant } from "../../utils/constants";
import { useTranslation } from "react-i18next";
import moment from "moment";
import "./PlanManagement.css"
const Usermanagement = () => {
  const { t } = useTranslation();
  const [page, setPage] = useState(constant.PAGE_ONE);
  const [limit, setLimit] = useState(constant.PER_PAGE_TEN);
  const [status, setStatus] = useState("all");
  const isSlider = useSlider();
  const [company, setCompany] = useState("{}");
  let comp = JSON?.parse(company);
  const { data, refetch } = useQuery({
    queryKey: ["companyPlans-list", page, limit, status, comp?.id],
    queryFn: async () => {
      const resp = await getCompanyPlansList(page, limit,comp?.id, status);
      return resp?.data?.data;
    },
  });
  const { data: companyList } = useQuery({
    queryKey: ["company-list"],
    queryFn: async () => {
      const resp = await getAllCompany(1, 50);
      return resp?.data?.data;
    },
  });
  const handleAction = async (data) => {
    try {
      const res=await changeCompanyPlanStatus(data);
      if(res.data){
        refetch();
      }
    } catch (err) {
      console.error("Error:", err);
    } finally {
    }
  };
  return (
    <div className="mainbox">
      <Sidebar />
      <div className={isSlider ? "body-content close" : "body-content open"}>
        <div className="d-flex align-items-center justify-content-between">
          <h2 className="mainhead font-24">{t("sideBar.companyPlanManagement")}</h2>
          
        </div>
        <Row className="align-items-center">
          <Col md={8}>
            <div className="d-flex align-items-center">
              <div className="d-flex align-items-center me-3">
                <label className="labelText text-nowrap">
                  {t("user.company")}:
                </label>
                <select
                  className="form-select selectfeild"
                  value={company}
                  onChange={(e) => {
                    setCompany(e.target.value);
                  }}
                >
                  {companyList?.companies &&
                  companyList?.companies?.length > 0 ? (
                    <>
                      <option value="{}">{t("user.all")}</option>
                      {companyList?.companies?.map((item, index) => {
                        return (
                          <option
                            value={JSON.stringify({
                              id: item?._id,
                              domain: item?.uuid,
                            })}
                            key={index}
                          >
                            {item?.name}
                          </option>
                        );
                      })}
                    </>
                  ) : (
                    <option value="{}">{t("user.noOptions")}</option>
                  )}
                </select>
              </div>
              <div className="d-flex align-items-center me-3">
                <label className="labelText">{t("planManagement.status")}:</label>
                <select
                  className="form-select selectfeild"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <option value="all">{t("planManagement.all")}</option>
                  <option value="active">{t("planManagement.active")}</option>
                  <option value="requested">{t("planManagement.requested")}</option>
                  <option value="rejected">{t("planManagement.rejected")}</option>
                  <option value="cancelled">{t("planManagement.cancelled")}</option>
                  <option value="expired">{t("planManagement.expired")}</option>
                </select>
              </div>
            </div>
          </Col>
          <Col md={4} className="py-4">
            <div className="sidebarBox">
              <div className="sidebar-box search-form-wrap mb-0">
                <div className="search-form">
                  <div className="form-group">
                    <span className="iconsearch">
                    </span>
                    <div
                      className="form-control border-0"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <div className="table-responsive tableOut">
          <table className="table tableDashboard">
            <thead className="thead-dark">
              <tr>
                <th>#</th>
                <th>{t("planManagement.orderId")}</th>
                <th>{t("user.companyName")} </th>
                {/* <th>{t("product.location")} </th> */}
                <th>{t("payment.planName")} </th>
                <th>{t("payment.price")}</th>
                <th>{t("task.startTime")} </th>
                <th>{t("task.endTime")} </th>
                <th>{t("planManagement.status")} </th>
                <th>{t("globals.action")} </th>
              </tr>
            </thead>

            <tbody>
              {data?.plans && data?.plans?.length > 0 ? (
                data?.plans?.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{(page - 1) * limit + (index + 1)}</td>
                      <td>{item?.orderId}</td>
                      <td className="text-capitalize">
                        {item?.companyName}
                      </td>
                      {/* <td>{"location"}</td> */}
                      <td>{item.planDetails?.[0]?.interval??"--"}</td>
                      <td>{item.planDetails?.[0]?.unitAmount}</td>
                      <td>{moment(item?.start_date).format("lll")}</td>
                      <td>{moment(item?.end_date).format("lll")}</td>
                      <td className="text-capitalize">{item?.status}</td>
                      <td>
                        <div className="rightList">
                            <Dropdown>
                              <Dropdown.Toggle
                                variant="success"
                                id="dropdown-basic"
                              >
                                <BsThreeDotsVertical />
                              </Dropdown.Toggle>

                              <Dropdown.Menu>
                                {
                                    item?.status=="requested"?<>
                                    <Dropdown.Item
                                  onClick={() => handleAction({id:item._id,status:"active"})}
                                >
                                  Mark as Activated
                                </Dropdown.Item>
                                <Dropdown.Item
                                  onClick={() => handleAction({id:item._id,status:"rejected"})}
                                >
                                  Mark as Rejected
                                </Dropdown.Item>
                                    </>:item?.status=="active"?<>
                                    <Dropdown.Item
                                  onClick={() => handleAction({id:item._id,status:"cancelled"})}
                                >
                                  Mark as Cancelled
                                </Dropdown.Item>
                                    </>:<>
                                    <Dropdown.Item
                                 
                                >
                                  No Action
                                </Dropdown.Item></>
                                }
                                
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={10} className="text-center">
                    <h4>{t("user.companyPlansNotFound")}</h4>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <Pagination
          page={page}
          setPage={setPage}
          limit={limit}
          setLimit={setLimit}
          totalPages={data?.total_pages}
          total={data?.total}
          length={data?.plans?.length}
        />
      </div>
    </div>
  );
};

export default Usermanagement;
